// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/circle-plus.js';

import { paths } from '../generated/circle-plus';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('circle-plus', Original, paths);
